export const DAILYUPDATE_ADD="DAILYUPDATE_ADD";
export const DAILYUPDATE_LIST="DAILYUPDATE_LIST";
export const DAILYUPDATE_BYID_PERQUATER="DAILYUPDATE_BYID_PERQUATER";